import PageContainer from 'publish/layout/PageContainer';
import React from "react";
import LayoutAside from "../LayoutAside";
import {observer} from "mobx-react-lite"
import userStore from "common/user/store/UserStore";

function ContentsContainer() {
    const tbSysUser = userStore.userModel?.getTbSysUser();
    return (
        <PageContainer session={false}>
            <LayoutAside />
            <div>{tbSysUser && JSON.stringify(tbSysUser)}</div>

        </PageContainer>
    );
}
export default observer(ContentsContainer);